export default "__VITE_ASSET__CkvL0OdN__"